
















































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import SpecsApi from '@/api/goods/specs'

@Component({
  components: {}
})
export default class GoodsSpecs extends AbpBase {
  isCheckAll: boolean = false
  columns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center'
    // },
    {
      title: '编号',
      key: 'id',
      align: 'center'
    },
    {
      title: '规格名称',
      key: 'name',
      align: 'center'
    },
    {
      title: '规格值',
      slot: 'productSalesAttributeValues',
      align: 'left'
    },
    {
      title: '备注',
      key: 'remark',
      align: 'center'
    },
    {
      title: '排序',
      width: 100,
      align: 'center',
      key: 'displayOrder'
    },
    {
      title: '操作',
      slot: 'action',
      width: 170,
      align: 'center'
    }
  ]
  loading: boolean = false
  tableData: any[] = []
  currentPage = 1
  pageSize = 10
  totalCount = 0

  created() {
    this.getTableData()
  }

  getTableData() {
    console.log('getTableData')
    let { pageSize, currentPage } = this
    SpecsApi.getList(pageSize, currentPage)
      .then(res => {
        this.loading = false
        let { totalCount, items } = res.data
        this.totalCount = totalCount
        this.tableData = items
      })
      .catch(() => {
        this.loading = false
        this.totalCount = 0
        this.tableData = []
      })
  }

  getProductSalesAttributeValues(arr: any[]) {
    return arr.map(item => item.name).join('，')
  }

  deleteRow(row: any) {
    this.$Modal.confirm({
      title: '提示',
      content: `删除无法恢复, 是否继续?`,
      onOk: () => {
        this.handleDelete(row.id)
      }
    })
  }

  handleDelete(id: string | number) {
    SpecsApi.deleteById(id).then(res => {
      this.getTableData()
    })
  }

  handleTableAllCancel() {
    this.isCheckAll = false
  }

  handleTableAll() {
    this.isCheckAll = true
  }

  handleSelectChange(selection) {
    this.isCheckAll = selection.length === this.tableData.length
  }

  handleSelectAll() {
    if (!this.tableData.length) return
    ;(this.$refs.selection as any).selectAll(!this.isCheckAll)
  }

  deleteSelectd() {
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      console.log('执行删除')
      this.$Modal.confirm({
        title: '批量删除商品规格',
        content: `是否删除已选中的商品规格?`,
        onOk: () => {
          console.log('点了确定了')
        }
      })
    }
  }

  pageChange(currentPage) {
    this.currentPage = currentPage
    this.getTableData()
  }
  pageSizeChange(pageSize) {
    this.pageSize = pageSize
    this.currentPage = 1
    this.getTableData()
  }
}
